module.exports = __webpack_public_path__ + "img/0Q3A2365_P_L_Wood.572fcb5c.jpg";